import { useEffect, useState } from 'react'
import { FinancialSettings } from '@components/settings/financial'
import { SchedulerSettings } from '@components/settings/scheduler'
import { useUserStore } from '@caradasstore/UserStore'
import { useCenterStore } from '@caradasstore/CenterStore'
import { useLoadingStore } from '@caradasstore/LoadingStore'
import { AdasBox } from '@components/wrapper-components'
import { getCalibrationCenter } from 'api/api'
import { Logger } from '../../../logger'

export const GeneralSettings = () => {
  const currentUser = useUserStore((store) => store.currentUser)
  const ccId = useCenterStore((store) => store.ccId)
  const setCenterDetail = useCenterStore((store) => store.setCenterDetail)
  const setLoading = useLoadingStore((store) => store.setLoading)
  const isAdminUser = currentUser?.is_admin

  const [calibrationCenterData, setCalibrationCenterData] = useState(null)

  const fetchCalibrationCenter = async () => {
    try {
      setLoading(true)
      const response = await getCalibrationCenter({ ccid: ccId })
      setCalibrationCenterData(response.data)
      setCenterDetail(response.data)
    } catch (error) {
      Logger.error({ message: error, payload: { file: 'GeneralSettings', ccId } })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (ccId > 0) fetchCalibrationCenter()
  }, [ccId])

  return (
    <AdasBox sx={{ marginTop: '10px' }}>
      <FinancialSettings isAdminUser={isAdminUser} ccId={ccId} calibrationCenterData={calibrationCenterData} />
      {isAdminUser && (
        <SchedulerSettings
          isAdminUser={isAdminUser}
          ccId={ccId}
          calibrationCenterData={calibrationCenterData}
          refetchCalibrationCenter={fetchCalibrationCenter}
        />
      )}
    </AdasBox>
  )
}
